import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personnalisation',
  templateUrl: './personnalisation.component.html',
  styleUrls: ['./personnalisation.component.scss']
})
export class PersonnalisationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
